/*
 *  -----------------------------------------------------------------------
 *    <copyright file="admin-report-template.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import React from 'react';
import { SWRConfig } from 'swr';
import AdminCustomReportTemplateGrid from '@components/admin/admin-custom-report-template-grid';
import PageTitle from '@components/core/page-title/page-title';
import { useTranslation } from 'hooks';
import { IUser } from '@contexts/user-context';

const AdminCustomReportTemplate = ({ user }: { user: IUser }) => {
    const { t } = useTranslation();

    return (
        <>
            <PageTitle text={t('admin:manageReportTemplates')} className="mb-10" />
            {/* Prevent caching by overriding cache provider */}
            <SWRConfig value={{ provider: () => new Map() }}>
                <AdminCustomReportTemplateGrid orgKey={user?.organisation?.key} />
            </SWRConfig>
        </>
    );
};

export default AdminCustomReportTemplate;
